import React from "react";
import { Button } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { ClusterSchema } from "../../api-client";

type DashboardButtonType = {
  cluster?: ClusterSchema;
};

export const DashboardButton = ({
  cluster,
}: DashboardButtonType): React.ReactElement => {
  const showDashboard = cluster?.scheduler.currentState.state === "started";
  const isNotebook =
    cluster?.scheduler.spec.tags.coiledClusterType === "notebook";
  const dashUrl = cluster?.scheduler.dashboardAddress || "";
  const url = isNotebook ? dashUrl.replace("?", "/jupyter/lab/?") : dashUrl;
  const label = isNotebook ? "Jupyter Lab" : "Dask Dashboard";

  return (
    <Button
      component="a"
      endIcon={<OpenInNewIcon />}
      size="small"
      variant="secondary"
      disabled={!showDashboard}
      href={url}
      target="_blank"
      rel="noreferrer"
    >
      {label}
    </Button>
  );
};
